import { config } from "@config";

export const mediaQuery = config.mediaQuery;
